// ABOUTME: Family definition for the relation/orders grids — siblings that can share saved layouts.
// ABOUTME: Each entry pairs a gridKey with an i18n label key used by the "share with" dropdown.

export const RELATION_ORDERS_FAMILY = {
    ACTIVE: {
        gridKey: "relations.orders",
        label: "processing",
    },
    ALL: {
        gridKey: "relations.orders.all",
        label: "all_orders",
    },
    SHIPPED: {
        gridKey: "relations.orders.shipped",
        label: "shipped",
    },
    CANCELLED: {
        gridKey: "relations.orders.cancelled",
        label: "cancelled",
    },
    BACKORDERED: {
        gridKey: "relations.orders.backordered",
        label: "backordered",
    },
    SNOOZED: {
        gridKey: "relations.orders.snoozed",
        label: "snoozed",
    },
    ACTION_REQUIRED: {
        gridKey: "relations.orders.actionrequired",
        label: "action_required",
    },
};

export const RELATION_ORDERS_IMPORT = {
    IMPORT: {
        gridKey: "relations.orders.import",
        label: "order_import",
    },
};

export const RELATION_ORDERS_LINES = {
    LINES: {
        gridKey: "relations.orders.orderlines",
        label: "orderlines",
    },
};

export const RELATION_ORDERS_SHIPMENTS = {
    SHIPMENTS: {
        gridKey: "relations.orders.shipments",
        label: "shipments",
    },
};
export const RELATION_ORDERS_BOLLVB = {
    BOLLVB: {
        gridKey: "relations.orders.bol_lvb",
        label: "bol_lvb",
    },
};
export const RELATION_ORDERS_AMAZONFBA = {
    AMAZONFBA: {
        gridKey: "relations.orders.amazon_fba",
        label: "amazon_fba",
    },
};
